export const environment = {
	production: false,
	api: {
		apiV1: 'https://api.newxlife.xl.co.id/prod',
	},
	foURL: 'https://www.newxlife.xlsmart.co.id/en/',
};
